<div data-crlat="tabContent" class="favourites-wrapper sk-container" [ngClass]="{ 'sk-loading': applyingParams }">
    @if (displayPageHeader) {
        <top-bar [title]="'sb.favouriteMatches'" [path]="'favourites'"></top-bar>
    }
    @if (state.error || !isUserLoggedIn) {
        <request-error
            [loadFailed]="state.error"
            [loginNeed]="!isUserLoggedIn"
            [errorMsg]="introductoryText"
            (reloadFn)="reloadComponent()"></request-error>
    }
    <loading-screen [displayed]="applyingParams" [isUsedFromWidget]="isWidgetColumn"></loading-screen>
    @if (!applyingParams && !state.error && isUserLoggedIn) {
        <div class="container-content" data-crlat="accordionsList">
            @if (matches?.length) {
                <div class="container-inner-content" data-crlat="favourites.group">
                    @if (showHeader) {
                        <div class="favourite-buttons">
                            <button class="btn btn-style1" (click)="removeAllFavourites()" data-crlat="clearFavouritesButton">
                                <span [i18n]="'favourites.clearFavourites'"></span>
                            </button>
                        </div>
                    }
                    @if (showHeader) {
                        <odds-card-header [events]="matches" [isFavorite]="true" data-crlat="eventOddsHeader"> </odds-card-header>
                    }
                    @for (match of matches; track match.id ?? 0) {
                        @if (isFavourite([match])) {
                            <odds-card-component
                                [event]="match"
                                [selectedMarket]="match.markets?.[0].name"
                                [gtmModuleTitle]="'favourites'"
                                data-crlat="favourites.groupItem">
                            </odds-card-component>
                        }
                    }
                </div>
            }

            <div class="item-inner item-btm-pad" data-crlat="widgetLoggedText">
                @if (!matches.length) {
                    <span [i18n]="'favourites.noFavouriteMatches'"></span>&nbsp;
                }
                <span [i18n]="'favourites.browseFavouriteMatches'"></span>
            </div>

            <div class="favourite-buttons">
                <a
                    class="btn btn-style1"
                    [ngClass]="{ 'left': !widget, 'full-width': widget }"
                    [routerLink]="['/sport', 'football', 'matches']"
                    data-crlat="goToMatchesButton">
                    <span [i18n]="'favourites.goToMatches'"></span>
                </a>

                @if (widget) {
                    <br />
                }

                <a
                    class="btn btn-style1"
                    [ngClass]="{ 'right': !widget, 'full-width': widget }"
                    [routerLink]="['/in-play', 'football']"
                    data-crlat="goToInPlayMatchesButton">
                    <span [i18n]="'favourites.goToInPlayMatches'"></span>
                </a>
            </div>
        </div>
    }
</div>
